import { supportedLanguages } from '../../static/supportedLanguages';

export const findLocaleByLanguage = (language: string) =>
  supportedLanguages.find(lang => lang.id === language)?.locale as string;
